var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import { Button, layouts as ButtonLayouts, } from '@food/ui/build/dist/src/Button';
import { Field } from '@food/ui/build/dist/src/Field';
import { SOCIAL_LOGIN_LAYOUTS } from './SocialLogin';
import { registerClass, classNames, subClass, } from '@food/css-manager';
var flexRow = registerClass(function () { return "\n\tflex-direction: row;\n"; });
var flexCol = registerClass(function () { return "\n\tflex-direction: column;\n"; });
var stepSection = registerClass(function (theme, sc) { return "\n\tpadding: " + (theme.ratios.l / 4) * theme.font.baseSize + "px " + theme.ratios.l *
    theme.font.baseSize + "px;\n\n\t> div {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\n\t\t> div {\n\t\t\tmargin: " + (theme.ratios.l / 2) * theme.font.baseSize + "px;\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n\t\n\t." + sc('renew-email') + " {\n\t\tfont-weight: " + theme.font.weights.semibold + "\n\t}\n\t\n\t." + sc('renew-intro') + " {\n\t\tmargin: 1em;\n\t\ttext-align: center;\n\t}\n\t\n\t." + sc('change-login-type') + " {\n\t\ttext-align: center;\n\t}\n\t\n\t." + sc('login-buttons') + " {\n\t\ttext-align: center;\n\n\t\t>button {\n\t\t\tmargin: " + (theme.ratios.xl / 2) * theme.font.baseSize + "px;\n\t\t}\n\t}\n\t\n\t&." + sc('layout', 'STANDARD') + " > div > div {\n\t\tflex-basis: " + theme.font.baseSize + "px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t}\n"; });
var sc = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return subClass.apply(void 0, __spreadArrays([stepSection], args));
};
var marginBottom = registerClass(function (theme) {
    return "margin-bottom: " + theme.ratios.l * theme.font.baseSize + "px;";
});
var TraditionalLogin = /** @class */ (function (_super) {
    __extends(TraditionalLogin, _super);
    function TraditionalLogin(props) {
        var _this = _super.call(this, props) || this;
        _this.setter = function (field) { return function (event) {
            var news = {};
            news[field] = event.target.value;
            _this.setState(function (prev) { return (__assign(__assign({}, prev), news)); });
        }; };
        _this.state = {
            email: props.isRenew && props.fixedEmail ? props.fixedEmail : '',
            password: '',
        };
        return _this;
    }
    TraditionalLogin.prototype.render = function () {
        var _a = this.state, email = _a.email, password = _a.password;
        var _b = this.props, onLogin = _b.onLogin, loading = _b.loading, logoElem = _b.logoElem, errors = _b.errors, t = _b.t, changePhase = _b.changePhase, isRenew = _b.isRenew, layout = _b.layout, orLogout = _b.orLogout;
        if (loading) {
            return (React.createElement("section", null, t(templateObject_1 || (templateObject_1 = __makeTemplateObject(["loading"], ["loading"]))),
                "..."));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("h2", null, t(isRenew ? 'Renew your authentication' : 'Sign In / Register')),
            React.createElement("section", { className: classNames(stepSection, sc('layout', layout)) },
                React.createElement("div", { className: layout === SOCIAL_LOGIN_LAYOUTS.STANDARD
                        ? flexRow
                        : flexCol },
                    logoElem,
                    React.createElement("div", null,
                        React.createElement("div", { className: isRenew ? sc('renew-intro') : '' },
                            isRenew && (React.createElement(React.Fragment, null, t(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Insert the password to renew as"], ["Insert the password to renew as"]))),
                                ' ',
                                React.createElement("span", { className: sc('renew-email') }, email),
                                ":")),
                            !isRenew && React.createElement(React.Fragment, null, t(templateObject_3 || (templateObject_3 = __makeTemplateObject(["Use the credentials we gave you"], ["Use the credentials we gave you"]))),
                                ":")),
                        errors,
                        React.createElement("div", { className: marginBottom },
                            React.createElement("form", { onSubmit: function () { return onLogin({ email: email, password: password }); } },
                                React.createElement(Field, null,
                                    React.createElement("input", { disabled: isRenew, type: isRenew ? 'hidden' : 'email', placeholder: "you@domain.com", value: email, onChange: this.setter('email'), onKeyPress: function (e) {
                                            if (e.key === 'Enter' &&
                                                email &&
                                                password) {
                                                onLogin({ email: email, password: password });
                                            }
                                        } })),
                                React.createElement(Field, null,
                                    React.createElement("input", { type: "password", placeholder: "password", value: password, onChange: this.setter('password'), onKeyPress: function (e) {
                                            if (e.key === 'Enter' &&
                                                email &&
                                                password) {
                                                onLogin({ email: email, password: password });
                                            }
                                        } })),
                                React.createElement("div", { className: sc('login-buttons') },
                                    React.createElement(Button, { disabled: !email || !password, label: t(isRenew ? 'Renew' : 'Sign In'), type: "success", onClick: function () {
                                            onLogin({ email: email, password: password });
                                        } }),
                                    isRenew && (React.createElement(Button, { type: 'alt', onClick: orLogout, layout: ButtonLayouts.LINK, label: t(templateObject_4 || (templateObject_4 = __makeTemplateObject(["... or Logout"], ["... or Logout"]))) }))))),
                        !isRenew && (React.createElement("div", { className: sc('change-login-type') },
                            React.createElement(Button, { label: t(templateObject_5 || (templateObject_5 = __makeTemplateObject(["Sign In with your social account"], ["Sign In with your social account"]))), layout: ButtonLayouts.LINK, onClick: function () {
                                    changePhase('LOGIN');
                                } }))))))));
    };
    return TraditionalLogin;
}(React.Component));
export { TraditionalLogin };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=TraditionalLogin.js.map